import restApi from "@common/utils/api/restApi";
import UrlAssembler from "url-assembler";

export const adicRestApi = restApi;

export const adicRestApiAdUrl = UrlAssembler().segment("/ad");

export const adicRestApiThemeUrl = UrlAssembler().segment("/recommend");

export const adicRestApiSearchUrl = UrlAssembler().segment("/search");

export const adicRestApiPangoUrl = UrlAssembler().segment("/pang-go");

export const adicRestApiJobUrl = UrlAssembler().segment("/job");

export const adicRestApiForumUrl = UrlAssembler().segment("/forum");

export const adicRestApiJournalUrl = UrlAssembler().segment("/journal");

export const adicRestApiLitUrl = UrlAssembler().segment("/lit");

export const adicRestApiMypageUrl = UrlAssembler().segment("/mypage");

export const adicRestApiAuthUrl = UrlAssembler().segment("/auth");

export const adicRestApiStatUrl = UrlAssembler().segment("/stat");
